module.exports = __webpack_public_path__ + "static/logo-ba94dff23f2e24c938ba48fb6a8eb814.png";